import { Cloud, Database, Eye, FileCheck2, KeyRound, LockKeyhole, ShieldCheck, Users } from 'lucide-react'
import { PageHero } from './shared'

export function SecurityPage() {
  return (
    <>
      <PageHero
        title="How you stay in control"
        copy="DAWN is designed to help with work without quietly taking over the business. You choose what it can see, what it can prepare and what always needs a person to approve it."
      />
      <section className="section">
        <div className="container security-grid">
          {[
            ['Your business stays separate', 'Each customer has a separate workspace so one company’s information is not mixed with another’s.', Database],
            ['People get the right level of access', 'Owners, team members and approvers can be given different permissions based on what they need to do.', Users],
            ['Connections can be limited or removed', 'DAWN should ask only for the access needed for an agreed job, and that access can be withdrawn.', KeyRound],
            ['Passwords and service keys stay out of prompts', 'Sensitive connection details belong in protected storage rather than ordinary chat messages or browser forms.', LockKeyhole],
            ['Important actions wait for approval', 'Messages, publishing, spending, deployment and destructive changes can be stopped until a person confirms them.', FileCheck2],
            ['You can see what happened', 'Work, approvals, changes, usage and errors are recorded so the system does not become invisible.', Eye],
            ['You can ask for data to be exported or removed', 'Production onboarding will include clear rules for keeping, exporting and deleting business information.', ShieldCheck],
            ['Larger businesses can use a more private setup', 'Where needed, DAWN can be placed in a separate environment with tighter controls.', Cloud],
          ].map(([title, copy, Icon]) => (
            <article key={title as string}><Icon size={23} /><h3>{title as string}</h3><p>{copy as string}</p></article>
          ))}
        </div>
      </section>
      <section className="section security-disclosure">
        <div className="container security-disclosure__inner">
          <ShieldCheck size={34} />
          <div>
            <h2>Honest current-status notice</h2>
            <p>The public review environment uses example information. It does not contain live customer data and cannot send messages, publish content, spend money or make destructive changes. Those capabilities remain locked until the required access, testing and approvals are in place.</p>
          </div>
        </div>
      </section>
    </>
  )
}
